import { AccountDetailsView } from '../views/index';
import { AccountDetails } from '../dtos/account-details';
import { DATE_MDY, DATE_TIME } from '../../utils/date/index';
import { IS_NOT_NULL_OR_UNDEFINED } from './../../utils/commonUtils/validation-utils';

export const ACCOUNT_DETAILS_TYPE = (accountDetails: AccountDetails = null): AccountDetailsView => {
	let result = {} as AccountDetailsView;
	try {
		if (accountDetails != null) {
			result.APIToken = accountDetails.apiToken;
			result.createdAt = DATE_MDY(accountDetails.accountCreatedAt);
			result.daysToPay = accountDetails.daysToPay || null;
			result.dot = accountDetails.accountDot || '';
			result.fromEmail = accountDetails.accountFromEmail;
			result.accountId = accountDetails.accountId;
			result.mc = accountDetails.accountMc;
			result.name = accountDetails.accountName;
			result.numberOfUsers = accountDetails.users || 0;
			if (accountDetails.subscription != null && accountDetails.subscription != undefined) {
				result.plan = accountDetails.subscription.plan.displayName;
				result.planPrice = accountDetails.subscription.plan.price;
				result.subscriptionId = accountDetails.subscription.id;
				result.subscriptionCreatedAt = DATE_MDY(accountDetails.subscription.createdAt);
				result.nextPaymentDate = IS_NOT_NULL_OR_UNDEFINED(
					accountDetails.subscription.nextPaymentDate
				)
					? DATE_MDY(accountDetails.subscription.nextPaymentDate)
					: 'N/A';
				result.lastPaymentDate = IS_NOT_NULL_OR_UNDEFINED(
					accountDetails.subscription.lastPaymentDate
				)
					? DATE_MDY(accountDetails.subscription.lastPaymentDate)
					: 'N/A';
				result.freeTrial = IS_NOT_NULL_OR_UNDEFINED(accountDetails.subscription.freeTrial)
					? DATE_MDY(accountDetails.subscription.freeTrial)
					: 'N/A';
				result.creditCardPayment =
					IS_NOT_NULL_OR_UNDEFINED(accountDetails.subscription.creditCardPayment) &&
					accountDetails.subscription.creditCardPayment;
			} else {
				result.plan = '';
				result.subscriptionId = null;
				result.creditCardPayment = false;
			}
			result.totalTruckSearches = accountDetails.truckSearches || 0;
			result.systemName = accountDetails.systemName || '';
			result.accountType = accountDetails.accountType;
			if (!accountDetails?.subscription?.plan?.seatPricing) {
				result.minimumSeats = `N/A`;
			} else {
				result.minimumSeats = accountDetails.minimumSeats;
			}
			result.loadsPerMonth = accountDetails.loadsPerMonth || 0;
			result.annualRevenue = accountDetails.annualRevenue || 0;
			if (IS_NOT_NULL_OR_UNDEFINED(accountDetails.termsAgreedAt)) {
				result.termsAgreedAt = DATE_TIME(accountDetails.termsAgreedAt);
			}
			result.timeZone = accountDetails.timeZone;
		}
	} catch (error) {
		console.log('ACCOUNT_DETAILS_TYPE error: ', error);
	}
	return result;
};
